<template>
    <div>
        <div class="activitate">
            <span class="title">
                <strong>{{ title }}</strong>
            </span>
        </div>
        <div v-if="warn" class="yellow-warning">
            <img src="@/assets/images/exclamation-mark-icon.png" alt="exclamation-mark-icon">            
            <div v-html="warn"></div>
        </div>
        <slot name="body"></slot>
    </div>
</template>

<script>
    export default{
        props: {
            title: {
                type: String,
                default: '',
            },
            warn: {
                type: String,
                default: '',
            },
        }
    }
</script>

<style scoped>
.activitate{
    margin-top: 30px;
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.yellow-warning{
    margin-top: 10px;
    background: #ffffff;
    padding: 15px 30px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border:1px solid #fcefcc;
}
.yellow-warning img{
    margin-right: 20px;
}
.yellow-warning >>> *{
    font-size: 12px;
    color: #525d6e;
    margin: 0;
}
.yellow-warning >>> ul{
    list-style: inside;
}
.activitate span{
    color: #515679;
}
</style>
